import React from 'react';
import {
  MissionSection,
  MissionText,
  MissionValueCard,
  MissionValues,
} from './Mission.styles';

const MissionStatement = () => {
  return (
    <MissionSection>
      <MissionText>
        <p className="eyebrowHeader">Why We Do What We Do</p>
        <h2>Our Mission</h2>
        <p>
          With over 20 years of experience, our mission is to help businesses
          build safer, stronger, and more compliant workplaces through online
          safety training, workplace safety solutions, trusted guidance, and
          practical support.
        </p>
        <p>
          From training and audits to safety manuals and compliance planning,
          every service we provide is built around protecting people, supporting
          teams, and giving organizations the confidence to operate safely.
        </p>
      </MissionText>

      <MissionValues>
        <MissionValueCard>
          <span>01</span>
          <h3>Safety First</h3>
          <p>
            We put worker safety at the center of every recommendation, program,
            and training solution.
          </p>
        </MissionValueCard>

        <MissionValueCard>
          <span>02</span>
          <h3>Practical Support</h3>
          <p>
            We focus on clear, usable safety systems that real teams can
            understand and apply.
          </p>
        </MissionValueCard>

        <MissionValueCard>
          <span>03</span>
          <h3>Trusted Guidance</h3>
          <p>
            We bring experience, accountability, and care to every client
            relationship.
          </p>
        </MissionValueCard>
      </MissionValues>
    </MissionSection>
  );
};

export default MissionStatement;
